import { call, put, takeLatest } from 'redux-saga/effects';
import { getEPPDetails } from '../api';
import { eppRequest, eppFetched, eppFetchFailed } from '../reducer/eppSlice';

interface EPPRequestAction {
  type: typeof eppRequest.type;
  payload: {
    accountId: string;
    customerId: string;
    isRefresh: boolean;
  };
}

export function* getEPPDetailsSaga(
  action: EPPRequestAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId, isRefresh } = action.payload;

    // Use the proper function signature here and ensure the API function matches the parameters
    const eppDetails: any = yield call(
      getEPPDetails,
      'epp',
      accountId,
      customerId,
      isRefresh
    );
    yield put(eppFetched(eppDetails));
  } catch (error: any) {
    yield put(eppFetchFailed(error.message || 'Something went wrong'));
  }
}

export function* watchEPPDetailsSaga() {
  yield takeLatest(eppRequest.type, getEPPDetailsSaga);
}
